import React from 'react';
import { Button } from '@mui/material';
import { Gavel as ApprovalActionIcon } from '@mui/icons-material';
import { WriteoffApprovalView } from '../../../../../../services/WriteoffService/types/writeoffTypes';
import { getApprovalStatus } from '../templates';
import { canUserApprove } from '../hooks';
import { actionButtonStyles } from '../styles';

interface ActionButtonProps {
  approval: WriteoffApprovalView;
  approvals: WriteoffApprovalView[];
  userDisplayName: string;
  isInApprovalStatus: boolean;
  onApprovalAction: (approval: WriteoffApprovalView, readOnly?: boolean) => void;
}

/**
 * Action button for approval actions (Act/Change/View).
 */
const ActionButton: React.FC<ActionButtonProps> = ({
  approval,
  approvals,
  userDisplayName,
  isInApprovalStatus,
  onApprovalAction
}) => {
  const status = getApprovalStatus(approval);
  const canApprove = canUserApprove(approval, userDisplayName, approvals);

  if (isInApprovalStatus && canApprove) {
    const isPending = status === 'Pending';
    return (
      <Button
        variant="contained"
        size="small"
        startIcon={<ApprovalActionIcon sx={{ fontSize: 12 }} />}
        onClick={() => onApprovalAction(approval)}
        sx={{
          ...actionButtonStyles.base,
          ...(isPending ? actionButtonStyles.act : actionButtonStyles.change)
        }}
      >
        {isPending ? 'Act' : 'Change'}
      </Button>
    );
  }

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={() => onApprovalAction(approval, true)}
      sx={{
        ...actionButtonStyles.base,
        ...actionButtonStyles.view
      }}
    >
      View
    </Button>
  );
};

export default ActionButton;
